<template>
  <!-- Vue is attached here -->
  <v-app>
    <TopBar />
    <v-content>
      <v-container fluid dark>
        <router-view>
          <!-- Views are injected here -->
        </router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Accordion from "./components/Accordion";
import Card from "./components/Card";
import Legend from "./components/Legend";
import MapLegendLi from "./components/MapLegendLi";
import ListItem from "./components/ListItem";
import Sublist from "./components/Sublist";
import TopBar from "./components/TopBar";

export default {
  name: "App",
  components: {
    Accordion,
    Card,
    Legend,
    MapLegendLi,
    ListItem,
    Sublist,
    TopBar
  },

  created() {
    this.$vuetify.theme.dark = true;
  }
};
</script>

<style lang="scss">
/* Removes scrollbars from application */
::-webkit-scrollbar {
  display: none;
}

.theme--dark.v-list {
  background-color: #5b665b;
}

html,
body {
  overflow-y: auto !important;
  overflow-x: hidden;
}

-webkit-scrollbar {
  display: none;
}

body,
main {
  background-color: #323c32 !important;
}

/* Removes more bottom margin from checkbox */
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0 !important;
}

/* Removes top padding and margin from checkboxes */
.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

table,
td {
  width: 100%;
}
// TODO: Check this more thoroughly
.v-application--is-ltr .v-input--selection-controls__input {
  margin: 1rem 0 0.25rem;
}

.width-50 {
  width: 50% !important;
}

.ordered-list-alpha {
  list-style-type: lower-alpha !important;
}

.overflow-auto {
  overflow: auto !important;
}

button.no-icon > .v-expansion-panel-header__icon {
  display: none !important;
}

.no-list-type {
  list-style-type: none;
}

.img-container {
  text-align: center;
  margin: 0 auto;
  img {
    width: 100%;
  }
}

// Overwrites Primary Text to white
.v-application .primary--text,
p {
  color: #fff !important;
  caret-color: #fff !important;
}

/* For Risk Matrix Table Overflow on small screens */
@media only screen and (max-width: 400px) {
  .v-expansion-panel-content#riskMatrix > .v-expansion-panel-content__wrap {
    overflow: hidden;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
